import { WarningRounded } from '@mui/icons-material'

interface FormErrorProps {
  message: string | undefined
  className?: string | null
  mt?: number | null
  mb?: number | null
}

const FormError = ({ message, className, mt, mb }: FormErrorProps) => {
  if (!message) {
    return null
  }

  return (
    <div
      className={`invalidErrorMsg${
        mt !== null ? ` mt-${mt === undefined ? 2 : mt}` : ''
      }${
        mb != null ? ` mb-${mb}` : ''
      } d-flex align-items-center py-2 px-3 bg-secondary text-secondary rounded-5 bg-opacity-10 ${className}`.trim()}
    >
      <WarningRounded
        style={{ color: '#F01B1B', width: 22, height: 22, marginLeft: -3 }}
      />
      <span className="ms-2 small" style={{ color: '#F01B1B' }}>
        {message}
      </span>
    </div>
  )
}

export default FormError
